import React from 'react';
import translate from 'i18n/translate';
import Axios from 'axios';
import { BASE_URL } from 'utils/constants';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
      subject: ''
    };
  }

  handleSubmit() {
    Axios.post(`${BASE_URL}/api/contact`, this.state).then(response => {
      this.resetForm();
    });
  }

  resetForm() {
    this.setState({ name: '', email: '', message: '', subject: '' });
  }

  render() {
    return (
      <div className="contact-form">
        <form id="contact-form" onSubmit={() => this.handleSubmit()}>
          <div className="d-flex justify-content-between">
            <div className="form-group child-48">
              <label htmlFor="name">{translate('yourName')}</label>
              <input
                type="text"
                className="form-control"
                id="name"
                value={this.state.name}
                onChange={e => this.onChange(e)}
              />
            </div>
            <div className="form-group child-48">
              <label htmlFor="exampleInputEmail1">
                {translate('emailAddress')}
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                aria-describedby="emailHelp"
                value={this.state.email}
                onChange={e => this.onChange(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="">{translate('title')}</label>
            <input
              type="subject"
              className="form-control"
              id="subject"
              value={this.state.subject}
              onChange={e => this.onChange(e)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">{translate('message')}</label>
            <textarea
              className="form-control"
              rows="10"
              id="message"
              value={this.state.message}
              onChange={e => this.onChange(e)}
            />
          </div>

          <button type="submit" className="btn btn-primary">
            {translate('send')}
          </button>
        </form>
      </div>
    );
  }

  onChange(event) {
    const value = event.target.value;

    this.setState({ [event.target.id]: value });
  }
}

export default ContactForm;
